import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import IberoHelpers from '@/store/helpers.js'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
})

Vue.use(VuexI18n.plugin, store)

export default new Vuex.Store({
  getters,
  modules: {
    app,
  },
  mutations: {},
  state: {
    configAuth: {
      tenant: 'ba5b0a4d-6c68-4ac3-9d6e-c5b5a12a9d69',
      clientId: 'e289d29f-4de8-43a1-ad0f-e9ac9aa2eebc',
      redirectUri: process.env.VUE_APP_URL_URI,
      redirectUriLogout: process.env.VUE_APP_URL_URILOGOUT,
      cacheLocation: 'localStorage',
      ADAzure: process.env.VUE_APP_COF_ADAZURE,
    },
    ApiIbero: {
      WSParametric: process.env.VUE_APP_URL_WSPARAMETRIC,
      WSUtilitary: process.env.VUE_APP_URL_WSUTILITARY,
      WSAudit: process.env.VUE_APP_URL_WSAUDIT,
      WSIceBerg: process.env.VUE_APP_URL_ICEBERG,
    },
    linksRedirect: {
      redMine: 'http://redmineibero.ibero.edu.co:81/redmine/login',
      GLPI: 'http://mesadeayuda.ibero.edu.co/glpi/',
      PTEmple: process.env.VUE_APP_URL_PTEMPLE,
      PTEstud: process.env.VUE_APP_URL_PTESTUD,
    },
    filesIbero: {
      sizeFiles: 103000000,
      extFiles: 'gif|jpg|jpeg|png|docx|doc|pdf',
    },
    linkTermiCondi: 'https://ibero.edu.co/tratamiento-uso-datos-personales',
    dateFormat: 'dd/MM/yyyy',
    listEstrato: [
      { id: '1', value: '1' },
      { id: '2', value: '2' },
      { id: '3', value: '3' },
      { id: '4', value: '4' },
      { id: '5', value: '5' },
      { id: '6', value: '6' },
    ],
    listWork: [
      { id: 'Si, tiempo Completo', value: 'Si, tiempo Completo' },
      { id: 'Si, medio Tiempo', value: 'Si, medio Tiempo' },
      { id: 'Si, temporalmente', value: 'Si, temporalmente' },
      { id: 'No trabajo', value: 'No trabajo' },
    ],
    listPersons: [
      { id: '0', value: '0' },
      { id: '1', value: '1' },
      { id: '2', value: '2' },
      { id: '3', value: '3' },
      { id: '4', value: '4' },
      { id: '5', value: '5' },
    ],
    listMAterial: [
      { id: 'Computador, Conexión a internet, Audífonos, Microsoft (Word, Power point, Excel)', value: 'Computador, Conexión a internet, Audífonos, Microsoft (Word, Power point, Excel)' },
      { id: 'Computador, Conexión a internet, Audífonos', value: 'Computador, Conexión a internet, Audífonos' },
      { id: 'Computador, Conexión a internet', value: 'Computador, Conexión a internet' },
      { id: 'Computador', value: 'Computador' },
      { id: 'No cuento con herramientas', value: 'No cuento con herramientas' },
    ],
    /* listAddress: [
      { id: '1', value: 'Calle' },
      { id: '2', value: 'Carrera' },
      { id: '3', value: 'Avenida' },
      { id: '4', value: 'Avenida Carrera' },
      { id: '5', value: 'Avenida Calle' },
      { id: '6', value: 'Circular' },
      { id: '7', value: 'Circunvalar' },
      { id: '8', value: 'Diagonal' },
      { id: '9', value: 'Manzana' },
      { id: '10', value: 'Transversal' },
      { id: '11', value: 'Vía' },
      { id: '12', value: 'Vereda' },
    ], */
    listAddress: [
      { id: '1', nomenclature: 'AC', value: 'Avenida calle' },
      { id: '2', nomenclature: 'AD', value: 'Administración' },
      { id: '3', nomenclature: 'ADL', value: 'Adelante' },
      { id: '4', nomenclature: 'AER', value: 'Aeropuerto' },
      { id: '5', nomenclature: 'AG', value: 'Agencia' },
      { id: '6', nomenclature: 'AGP', value: 'Agrupación' },
      { id: '7', nomenclature: 'AK', value: 'Avenida carrera' },
      { id: '8', nomenclature: 'AL', value: 'Altillo' },
      { id: '9', nomenclature: 'ALD', value: 'Al lado' },
      { id: '10', nomenclature: 'ALM', value: 'Almacén' },
      { id: '11', nomenclature: 'AP', value: 'Apartamento' },
      { id: '12', nomenclature: 'APTDO', value: 'Apartado' },
      { id: '13', nomenclature: 'ATR', value: 'Atrás' },
      { id: '14', nomenclature: 'AUT', value: 'Autopista' },
      { id: '15', nomenclature: 'AV', value: 'Avenida' },
      { id: '16', nomenclature: 'AVIAL', value: 'Anillo vial' },
      { id: '17', nomenclature: 'BG', value: 'Bodega' },
      { id: '18', nomenclature: 'BL', value: 'Bloque' },
      { id: '19', nomenclature: 'BLV', value: 'Boulevard' },
      { id: '20', nomenclature: 'BRR', value: 'Barrio' },
      { id: '21', nomenclature: 'C', value: 'Corregimiento' },
      { id: '22', nomenclature: 'CA', value: 'Casa' },
      { id: '23', nomenclature: 'CAS', value: 'Caserío' },
      { id: '24', nomenclature: 'CC', value: 'Centro comercial' },
      { id: '25', nomenclature: 'CD', value: 'Ciudadela' },
      { id: '26', nomenclature: 'CEL', value: 'Célula' },
      { id: '27', nomenclature: 'CEN', value: 'Centro' },
      { id: '28', nomenclature: 'CIR', value: 'Circular' },
      { id: '29', nomenclature: 'CL', value: 'Calle' },
      { id: '30', nomenclature: 'CLJ', value: 'Callejón' },
      { id: '31', nomenclature: 'CN', value: 'Camino' },
      { id: '32', nomenclature: 'CON', value: 'Conjunto residencial' },
      { id: '33', nomenclature: 'CONJ', value: 'Conjunto' },
      { id: '34', nomenclature: 'CR', value: 'Carrera' },
      { id: '35', nomenclature: 'CRT', value: 'Carretera' },
      { id: '36', nomenclature: 'CRV', value: 'Circunvalar' },
      { id: '37', nomenclature: 'CS', value: 'Consultorio' },
      { id: '38', nomenclature: 'DG', value: 'Diagonal' },
      { id: '39', nomenclature: 'DP', value: 'Depósito' },
      { id: '40', nomenclature: 'DPTO', value: 'Departamento' },
      { id: '41', nomenclature: 'DS', value: 'Depósito sótano' },
      { id: '42', nomenclature: 'ED', value: 'Edificio' },
      { id: '43', nomenclature: 'EN', value: 'Entrada' },
      { id: '44', nomenclature: 'ES', value: 'Escalera' },
      { id: '45', nomenclature: 'ESQ', value: 'Esquina' },
      { id: '46', nomenclature: 'ESTE', value: 'Este' },
      { id: '47', nomenclature: 'ET', value: 'Etapa' },
      { id: '48', nomenclature: 'EX', value: 'Exterior' },
      { id: '49', nomenclature: 'FCA', value: 'Finca' },
      { id: '50', nomenclature: 'GJ', value: 'Garaje' },
      { id: '51', nomenclature: 'GS', value: 'Garaje sótano' },
      { id: '52', nomenclature: 'GT', value: 'Glorieta' },
      { id: '53', nomenclature: 'HC', value: 'Hacienda' },
      { id: '54', nomenclature: 'HG', value: 'Hangar' },
      { id: '55', nomenclature: 'IN', value: 'Interior' },
      { id: '56', nomenclature: 'IP', value: 'Inspección de Policía' },
      { id: '57', nomenclature: 'IPD', value: 'Inspección Departamental' },
      { id: '58', nomenclature: 'IPM', value: 'Inspección Municipal' },
      { id: '59', nomenclature: 'KM', value: 'Kilómetro' },
      { id: '60', nomenclature: 'LC', value: 'Local' },
      { id: '61', nomenclature: 'LM', value: 'Local mezzanine' },
      { id: '62', nomenclature: 'LT', value: 'Lote' },
      { id: '63', nomenclature: 'MD', value: 'Módulo' },
      { id: '64', nomenclature: 'MJ', value: 'Mojón' },
      { id: '65', nomenclature: 'MLL', value: 'Muelle' },
      { id: '66', nomenclature: 'MN', value: 'Mezzanine' },
      { id: '67', nomenclature: 'MZ', value: 'Manzana' },
      { id: '68', nomenclature: 'NOMBRE VIA', value: 'Vías de nombre común' },
      { id: '69', nomenclature: 'NORTE', value: 'Norte' },
      { id: '70', nomenclature: 'O', value: 'Oriente' },
      { id: '71', nomenclature: 'OCC', value: 'Occidente' },
      { id: '72', nomenclature: 'OESTE', value: 'Oeste' },
      { id: '73', nomenclature: 'OF', value: 'Oficina' },
      { id: '74', nomenclature: 'P', value: 'Piso' },
      { id: '75', nomenclature: 'PA', value: 'Parcela' },
      { id: '76', nomenclature: 'PAR', value: 'Parque' },
      { id: '77', nomenclature: 'PD', value: 'Predio' },
      { id: '78', nomenclature: 'PH', value: 'Penthouse' },
      { id: '79', nomenclature: 'PJ', value: 'Pasaje' },
      { id: '80', nomenclature: 'PL', value: 'Planta' },
      { id: '81', nomenclature: 'PN', value: 'Puente' },
      { id: '82', nomenclature: 'POR', value: 'Portería' },
      { id: '83', nomenclature: 'POS', value: 'Poste' },
      { id: '84', nomenclature: 'PQ', value: 'Parqueadero' },
      { id: '85', nomenclature: 'PRJ', value: 'Paraje' },
      { id: '86', nomenclature: 'PS', value: 'Paseo' },
      { id: '87', nomenclature: 'PT', value: 'Puesto' },
      { id: '88', nomenclature: 'PW', value: 'Park Way' },
      { id: '89', nomenclature: 'RP', value: 'Round Point' },
      { id: '90', nomenclature: 'SA', value: 'Salón' },
      { id: '91', nomenclature: 'SC', value: 'Salón comunal' },
      { id: '92', nomenclature: 'SD', value: 'Salida' },
      { id: '93', nomenclature: 'SEC', value: 'Sector' },
      { id: '94', nomenclature: 'SL', value: 'Solar' },
      { id: '95', nomenclature: 'SM', value: 'Súper manzana' },
      { id: '96', nomenclature: 'SS', value: 'Semisótano' },
      { id: '97', nomenclature: 'ST', value: 'Sótano' },
      { id: '98', nomenclature: 'SUITE', value: 'Suite' },
      { id: '99', nomenclature: 'SUR', value: 'Sur' },
      { id: '100', nomenclature: 'TER', value: 'Terminal' },
      { id: '101', nomenclature: 'TERPLN', value: 'Terraplén' },
      { id: '102', nomenclature: 'TO', value: 'Torre' },
      { id: '103', nomenclature: 'TV', value: 'Transversal' },
      { id: '104', nomenclature: 'TZ', value: 'Terraza' },
      { id: '105', nomenclature: 'UN', value: 'Unidad' },
      { id: '106', nomenclature: 'UR', value: 'Unidad residencial' },
      { id: '107', nomenclature: 'URB', value: 'Urbanización' },
      { id: '108', nomenclature: 'VRD', value: 'Vereda' },
      { id: '109', nomenclature: 'VTE', value: 'Variante' },
      { id: '110', nomenclature: 'ZF', value: 'Zona franca' },
      { id: '111', nomenclature: 'ZN', value: 'Zona' },
    ],
    localInf: [],
    IberoPresen: [],
    DocTypesList: [],
    StateList: [],
    FacultyList: [],
    ProgramList: [],
    ProgramList2: [],
    ProgramsList: [],
    PermanenceList: [],
    DegreeList: [],
    CityList: [],
    PeriodList: [],
    OperatorsByUser: [],
    OperatorList: [],
    itemList: [],
    CityListRes: [],
    CountriesList: [],
    CityListBirth: [],
    GenderList: [],
    EthnicityList: [],
    DesabilityList: [],
    MaritalStatusList: [],
    EPSList: [],
    EPSQAList: [],
    EtniaList: [],
    ModalityList: [],
    PeriodoList: [],
    JornadaList: [],
    WorkdayList: [],
    HomDegreeList: [],
    DegreeDocumentList: {},
    TipocColegioList: [],
    CityListCol: [],
    DocTypesListICFES: [],
    PeriodProccess: { Sta_Active: true },
    OperatorGradeList: [],
    EvalRolList: [],
    PlanList: [],
    ImmediateBossesList: [],
    TeachersList: [],
    ProgramCodeList: [],
  },
  actions: {
    callIberoWS: function () {
      IberoHelpers.getDocTypeList(this)
      IberoHelpers.getStateList(this)
      IberoHelpers.getOperatorList(this)
      IberoHelpers.getDegreeList(this)
      IberoHelpers.getCountriesList(this)
      IberoHelpers.getGenderList(this)
      IberoHelpers.getEthnicityList(this)
      IberoHelpers.getDesabilityList(this)
      IberoHelpers.getMaritalStatusList(this)
      IberoHelpers.getEPSList(this)
      IberoHelpers.getEPSQAList(this)
      IberoHelpers.getWorkdayList(this)
      IberoHelpers.getPeriodList(this)
      IberoHelpers.getSchoolTypeList(this)
      IberoHelpers.getWorkdaySchoolList(this)
      IberoHelpers.getDegreeDocumentList(this)
      IberoHelpers.getBondsList(this)
      IberoHelpers.getPQRSList(this)
      IberoHelpers.getProgramsList(this)
      IberoHelpers.getAllCertificateType(this)
      IberoHelpers.getModalitiesList(this)
      IberoHelpers.getImmediateBossesList(this)
      IberoHelpers.getTeachersList(this)
      IberoHelpers.getProgramsCodeList(this)
      IberoHelpers.getFaculties(this)
    },
  },
})
